import { SmilingFlowerIcon } from 'baby-ui/foundation/BabylistIcons'
import ArrivalDateForm from './ArrivalDateForm/ArrivalDateForm'
import Slide, { Title } from '../../Slide/Slide'
import css from './arrival-date.styles.scss'

interface ArrivalDateProps {
  arrivalDate: string
  isHavingMultipleBabies: boolean
  onSaveArrivalDate: () => void
}

export default ({
  arrivalDate,
  isHavingMultipleBabies,
  onSaveArrivalDate,
}: ArrivalDateProps) => (
  <Slide>
    <div className={css.ArrivalDate__headerContainer}>
      <SmilingFlowerIcon />
      <div className={css.ArrivalDate__textContainer}>
        <Title className={css.ArrivalDate__title}>
          Congrats!
          <br />
          When is this babe arriving?
        </Title>
        <p className={css.ArrivalDate__subTitle}>
          This helps us personalize your experience.
        </p>
      </div>
    </div>
    <ArrivalDateForm
      initialValues={{ arrivalDate, isHavingMultipleBabies }}
      onSaveArrivalDate={onSaveArrivalDate}
    />
  </Slide>
)
